/*
 * Keeps the item count in the cart drawer header current.
 *
 * A quantity change inside the drawer re-renders the line items, the shipping
 * notice and the summary - but not the header, so the count beside the title
 * would go stale until the next full render. The new total is read back from
 * /cart.js rather than taken from the event payload, which carries the line
 * that changed rather than the new total.
 *
 * Progressive enhancement: the count is correct server-side on every full
 * render, so with this script blocked the header is right on open and only
 * drifts while the drawer stays open.
 *
 * The host element wraps <cart-drawer> rather than being it, because the theme
 * replaces that element's innerHTML on every cart render and a script hosted
 * on it would lose its listeners.
 */
if (!customElements.get('knuska-cart-drawer')) {
  class KnuskaCartDrawer extends HTMLElement {
    connectedCallback() {
      this.onCartChange = this.refresh.bind(this);
      document.addEventListener('on:cart:add', this.onCartChange);
      document.addEventListener('on:line-item:change', this.onCartChange);
      document.addEventListener('on:cart:change', this.onCartChange);
    }

    disconnectedCallback() {
      document.removeEventListener('on:cart:add', this.onCartChange);
      document.removeEventListener('on:line-item:change', this.onCartChange);
      document.removeEventListener('on:cart:change', this.onCartChange);
    }

    async refresh() {
      const count = this.querySelector('[data-cart-count]');
      if (!count) return;

      let cart;
      try {
        const response = await fetch(`${theme.routes.cart}.js`);
        if (!response.ok) return;
        cart = await response.json();
      } catch (e) {
        return;
      }

      count.textContent = `(${cart.item_count})`;
      count.hidden = cart.item_count === 0;
    }
  }

  customElements.define('knuska-cart-drawer', KnuskaCartDrawer);
}
